import React, { useState } from 'react'
import { Form } from 'react-bootstrap'

import "./RadioGroup.scss"

function RadioGroup ({model, items = [], radio, setRadio}) {

    let itemsFiltered = items.filter(i => i.model === model);

    return (
        <Form className="RadioGroup">
            {itemsFiltered.map(item => (
                <div key = {`inline-${item.id}`} className = "RadioButton">
                    <Form.Check 
                        inline
                        id = {item.id}
                        type = {item.type}
                        label = {item.label}
                        checked = {radio === item.id ? true : false}
                        onClick = {() => setRadio(item.id)} />
                </div>
            ))}
        </Form>
    )
}


export default RadioGroup;